import React, { type FunctionComponent, Fragment } from 'react'
import { FormattedMessage, FormattedRelativeTime } from 'react-intl'
import moment from 'moment'
import { selectUnit } from '@formatjs/intl-utils'
import { DashText } from 'legacy/dash-blocks/dash-text/DashText'
import { type OrdersListApiApproxGMV } from 'legacy/sections/orders/components/list/utils/ordersList.types'

interface Props {
  approxGmv?: OrdersListApiApproxGMV
}

export const OrdersListTabsFooter: FunctionComponent<Props> = ({ approxGmv }) => {
  if (!approxGmv) {
    return null
  }

  const lastUpdatedAt = approxGmv.last_updated_at
  const { value, unit } = selectUnit(moment(lastUpdatedAt).toDate())

  return (
    <Fragment>
      <DashText size="small">
        <FormattedMessage id="orders.nav.approx_gmv.info_delayed" />
      </DashText>

      {lastUpdatedAt && (
        <DashText size="small" color="neutral">
          <FormattedMessage
            id="orders.nav.approx_gmv.last_updated"
            values={{
              lastUpdatedAt: <FormattedRelativeTime value={value} unit={unit} />,
            }}
          />
        </DashText>
      )}
    </Fragment>
  )
}
